import validator from 'validator';

export const isPhoneNumber = (phoneNumber): boolean => {
  return validator.isMobilePhone(phoneNumber);
};

/**
 * Validates a caller number: must be exactly 10 digits and have an area code between 201–999.
 * Returns an error message string if invalid, or undefined if valid.
 */
export const validateCallerNumber = (callerNumber?: string): string | undefined => {
  if (!callerNumber) return undefined;
  if (callerNumber.length !== 10) {
    return 'Phone number must be exactly 10 digits';
  }
  const areaCode = parseInt(callerNumber.substring(0, 3), 10);
  if (areaCode < 201 || areaCode > 999) {
    return 'Area code must be between 201 and 999';
  }
  return undefined;
};

export const isEmailValid = (email: string): boolean => {
  if (!email) {
    return false;
  }

  return /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(email);
};

type ValidationResponse = boolean;

export const validMinLength = (str: string, len = 8): ValidationResponse => {
  return str.length >= len;
};

export const validMaxLength = (str: string, len = 20): ValidationResponse => {
  return str.length <= len;
};

export const validPresence = (str: string): ValidationResponse => {
  return Boolean(str.trim());
};

export const excludesProhibited = (str: string, invalid: string): ValidationResponse => {
  return !str.includes(invalid);
};

export const validMatch = (str: string, comp: string): ValidationResponse => {
  return str === comp;
};

export const validateName = ({ value }: { value: string }) => {
  const invalidPattern = /[|:^@<>"=]/;

  if (invalidPattern.test(value)) {
    return 'Invalid characters: | : @ ^ < > " =';
  }

  return '';
};
